import enGB from './en-GB';
import itIT from './it-IT';
import deDE from './de-DE';
export var AvailableLanguages;
(function (AvailableLanguages) {
    AvailableLanguages["itIT"] = "it-IT";
    AvailableLanguages["enGB"] = "en-GB";
    AvailableLanguages["deDE"] = "de-DE";
})(AvailableLanguages || (AvailableLanguages = {}));
export const messages = {
    'it-IT': itIT,
    'en-GB': enGB,
    'de-DE': deDE,
};
export default messages;
